<template>
  <div id="update_pwd" :style="{ backgroundImage: `url(${meta.bg})`, backgroundSize: 'cover', backgroundPosition: 'center' }">
    <top-bar />
    <logo />

    <div id="loginInfo">

      <div id="loginTitle">
        {{ $t('update_pwd["change"]') }}

        <span style="font-size: 28px;color:#FF5E00 ">{{ $t('update_pwd["Password"]') }}</span>
      </div>

      <div class="form">
        <div class="ipt-wrap ipt-pwd-wrap"><input v-model="form.oldPassword" :type='pwdFlag?"password":"text"'
                 :placeholder="$t('update_pwd[\'Please enter your current password\']')" maxlength="64">
          <div class="ipt-pwd-eye-wrap">
            <img v-show="pwdFlag" src="@/assets/eye-closed.svg" alt="" @click="changePwd">
            <img v-show="!pwdFlag" src="@/assets/eye-open.svg" alt="" @click="changePwd">
          </div>
        </div>
        <div class="ipt-wrap ipt-pwd-wrap"><input v-model="form.newPassword" :type='pwdFlag?"password":"text"'
                 :placeholder="$t('update_pwd[\'Please enter your password\']')" maxlength="64">
          <div class="ipt-pwd-eye-wrap">
            <img v-show="pwdFlag" src="@/assets/eye-closed.svg" alt="" @click="changePwd">
            <img v-show="!pwdFlag" src="@/assets/eye-open.svg" alt="" @click="changePwd">
          </div>
        </div>
        <div class="ipt-wrap ipt-pwd-wrap"><input v-model="form.newPassword2" :type='pwdFlag?"password":"text"'
                 :placeholder="$t('reg[\'Please confirm your password\']')" maxlength="64">
          <div class="ipt-pwd-eye-wrap">
            <img v-show="pwdFlag" src="@/assets/eye-closed.svg" alt="" @click="changePwd">
            <img v-show="!pwdFlag" src="@/assets/eye-open.svg" alt="" @click="changePwd">
          </div>
        </div>
      </div>

      <div style="padding: 63px 20px 33px 20px">
        <div id="changePwdBtn" @click="doChangePwd">
          {{ $t('update_pwd["Password"]') }}
        </div>
      </div>


    </div>

    <custom-dialog
      v-model="showDialog"
      width="500"
      :confirmText="$t('base.ok')"
      cancelType="primary"
      :confirmBtnLoading="confirmBtnLoading"
      @confirm="confirmModel"
      @change="changeModel"
      :title="$t('base.notice')"
    >
      <div>
        {{ confirmInfo }}
      </div>
    </custom-dialog>

  </div>
</template>

<script>
import meta from '../../utils/meta'
import CustomDialog from "../../components/alert.vue";
import axios from "../../utils/request";

export default {
  name: 'update_pwd',
  components: {CustomDialog},
  data() {
    return {
      confirmInfo:'',
      showDialog: false,
      confirmBtnLoading: '',
      form: {
        oldPassword: '',
        newPassword: '',
        newPassword2: ''
      },
      pwdFlag: true,
      callback: () => {},
      meta
    }
  },
  methods: {
    changePwd() {
      this.pwdFlag = !this.pwdFlag
    },
    goBack(){
      window.history.back();
    },
    confirmModel() {
      this.showDialog = false
      this.callback()
      this.confirmInfo = null
    },
    changeModel() {
      this.showDialog = false
      this.confirmInfo = null
    },
    doChangePwd() {
      if (!this.form.oldPassword){
        this.showDialog = true
        this.confirmInfo = this.$t('update_pwd["Please enter your current password"]')
      }
      if (!this.form.newPassword){
        this.showDialog = true
        this.confirmInfo = this.$t('update_pwd["Please enter your password"]')
      }
      if (!this.form.newPassword2){
        this.showDialog = true
        this.confirmInfo = this.$t('reg["Please confirm your password"]')
      }

      if (this.form.newPassword === this.form.newPassword2) {
        axios({
          method: "put",
          url: '/system/user/profile/updatePwd?newPassword='+this.form.newPassword+'&oldPassword='+this.form.oldPassword,
        }).then(({code, msg, data}) => {
          if (code === 200) {
            this.showDialog = true
            this.confirmInfo = this.$t('update_pwd["Change successfully"]')
            this.callback = () => {
              this.$router.back()
              this.callback = () => {}
            }
          } else {
            this.showDialog = true
            this.confirmInfo = msg
          }
        })
      } else {
        this.showDialog = true
        this.confirmInfo = this.$t('reg["Password mismatch."]')
      }

    }
  }
}
</script>

<style scoped>

#update_pwd {
  width: 100vw;
  min-height: 100vh;
  background-size: cover;
  background-attachment: fixed;
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 3.73vw 3.73vw 0;
  box-sizing: border-box;
}

#loginInfo {
  background: linear-gradient(180deg, #FFFFFF 0%, #F7FEF1 100%);
  box-shadow: 0px 7px 13px 0px rgba(5, 78, 171, 0.33);
  border-radius: 25px;
  position: relative;
  margin-top: 7.47vw;
}

#loginTitle {
  height: 40px;
  font-weight: 600;
  font-size: 18px;
  color: #000000;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  padding-left: 21px;
  padding-top: 27px;
  padding-bottom: 26px;
}

#changePwdBtn {
  height: 58px;
  background: linear-gradient(133deg, #F8B029 0%, #F6923D 100%);
  border-radius: 20px;
  padding: 0 20px;

  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 58px;
  text-align: center;
  font-style: normal;
  cursor: pointer;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 20px;
}

.ipt-wrap {
  display: flex;
  align-items: center;
}
.ipt-wrap input {
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;
  height: 48px;
  background: #fefefe;
  border-radius: 14px;
  border: 1px solid #C8C8C8
}

.ipt-pwd-wrap input {
  margin-right: -35px;
  padding-right: 38px;
}
.ipt-pwd-wrap > .ipt-pwd-eye-wrap {
  height: 100%;
  vertical-align: middle;
  display: inline-block;
  width: 20px;
  padding-left: 5px;
}
.ipt-pwd-wrap > .ipt-pwd-eye-wrap > img {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/views/update_pwd/index.vue